export default "__VITE_ASSET__DTR4IV2a__"